import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const ArrowBack = () => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M21.38 11.3751H4.17L11.81 4.05508C12.06 3.81508 12.06 3.42508 11.82 3.18508C11.58 2.94508 11.18 2.93508 10.94 3.17508L2.19 11.5551C2.08 11.6751 2 11.8251 2 11.9951C2 12.1651 2.07 12.3251 2.19 12.4351L10.94 20.8251C11.06 20.9451 11.22 20.9951 11.38 20.9951C11.54 20.9951 11.71 20.9351 11.83 20.8051C12.07 20.5651 12.06 20.1751 11.82 19.9351L4.17 12.6151H21.38C21.72 12.6151 22 12.3351 22 11.9951C22 11.6551 21.72 11.3751 21.38 11.3751Z" />
  </svg>
)

export default withDefaultStyles(ArrowBack)
